import * as React from "react";
import { Button } from "../../button/index";
import { logger } from "@lib/common";
import { Modal } from "../../layout/modal";
import { ModalTitle, ModalContent } from "../../layout/modal/content";
import { RotateLoader } from "../../loaders/rotate/index";
import { CoreUtils } from "@lib/common";
import { ImageUploadThumbnails } from "../../elements/image_upload.thumbnails";
import { LinkTag } from "../../elements/link";
import { Input } from "../input";
// @ts-ignore
import uploadcare from 'uploadcare-widget/uploadcare.full.min.js';
// @ts-ignore
import uploadcareTabEffects from 'uploadcare-widget-tab-effects';
import styled from "styled-components";
uploadcare.registerTab('preview', uploadcareTabEffects);
const ImageItemWrapper = styled.div `
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;
	margin-bottom: 5px;
`;
const ImageItemStyle = styled.div `
    display: flex;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #F1F4F7;
    color: #4B4F5E;
`;
const StockImages = [
    {
        name: "pizza-1",
        url: "https://images.unsplash.com/photo-1506354666786-959d6d497f1a",
    },
    {
        name: "pizza-2",
        url: "https://images.unsplash.com/photo-1448006531138-949dfde20011",
    },
    {
        name: "pizza-3",
        url: "https://images.unsplash.com/photo-1523982440192-e61efd063acb",
    },
    {
        name: "pizza-4",
        url: "https://images.unsplash.com/photo-1551978129-b73f45d132eb",
    },
    {
        name: "pizza-5",
        url: "https://images.unsplash.com/photo-1536622308015-0740925b8221",
    },
    {
        name: "pizza-6",
        url: "https://images.unsplash.com/photo-1552539618-7eec9b4d1796",
    },
    {
        name: "pasta-1",
        url: "https://images.unsplash.com/photo-1551183053-bf91a1d81141",
    },
    {
        name: "pasta-2",
        url: "https://images.unsplash.com/photo-1473093295043-cdd812d0e601",
    },
    {
        name: "pasta-3",
        url: "https://images.unsplash.com/photo-1550692530-44608cfe4f59",
    },
    {
        name: "burger-1",
        url: "https://images.unsplash.com/photo-1525164286253-04e68b9d94c6",
    },
    {
        name: "burger-2",
        url: "https://images.unsplash.com/photo-1550547660-d9450f859349",
    },
    {
        name: "burger-3",
        url: "https://images.unsplash.com/photo-1428660386617-8d277e7deaf2",
    },
    {
        name: "burger-4",
        url: "https://images.unsplash.com/photo-1511421616335-5a9846f1afcb",
    },
    {
        name: "burger-5",
        url: "https://images.unsplash.com/photo-1477259004500-ce2463b979ca",
    },
    {
        name: "burger-6",
        url: "https://images.unsplash.com/photo-1514996183542-72c207fee1e3",
    },
    {
        name: "western-1",
        url: "https://images.unsplash.com/photo-1551858985-777ee87ad343",
    },
    {
        name: "western-2",
        url: "https://images.unsplash.com/photo-1544025162-d76694265947",
    },
    {
        name: "western-3",
        url: "https://images.unsplash.com/photo-1548869205-3b74ad80e605",
    },
    {
        name: "western-4",
        url: "https://images.unsplash.com/photo-1542790197-ef1e1454a0bd",
    },
    {
        name: "western-5",
        url: "https://images.unsplash.com/photo-1527324688151-0e627063f2b1",
    },
    {
        name: "mexican-1",
        url: "https://images.unsplash.com/photo-1545062071-aa21095503da",
    },
    {
        name: "mexican-2",
        url: "https://images.unsplash.com/photo-1545062070-98b758d7d91c",
    },
    {
        name: "mexican-3",
        url: "https://images.unsplash.com/photo-1520218508822-998633d997e6",
    },
    {
        name: "mexican-4",
        url: "https://images.unsplash.com/photo-1505976231433-d7ebe8382bb5",
    },
    {
        name: "sushi-1",
        url: "https://images.unsplash.com/photo-1534604973900-c43ab4c2e0ab",
    },
    {
        name: "sushi-2",
        url: "https://images.unsplash.com/photo-1550749388-736d06e9c497",
    },
    {
        name: "sushi-3",
        url: "https://images.unsplash.com/photo-1540713304937-18ad930d3594",
    },
    {
        name: "sushi-4",
        url: "https://images.unsplash.com/photo-1545879429-677464262714",
    },
    {
        name: "japanese-1",
        url: "https://images.unsplash.com/photo-1498654896293-37aacf113fd9",
    },
    {
        name: "noodles-1",
        url: "https://images.unsplash.com/photo-1513613593045-5f00c10fb8d6",
    },
    {
        name: "noodles-2",
        url: "https://images.unsplash.com/photo-1512003867696-6d5ce6835040",
    },
    {
        name: "noodles-3",
        url: "https://images.unsplash.com/photo-1555126634-323283e090fa",
    },
    {
        name: "noodles-4",
        url: "https://images.unsplash.com/photo-1540162416395-16f7dfbb68d1",
    },
    {
        name: "cafe-1",
        url: "https://images.unsplash.com/photo-1550807014-1236e91b92d4",
    },
    {
        name: "cafe-2",
        url: "https://images.unsplash.com/photo-1549370699-e8c493402b69",
    },
    {
        name: "cafe-3",
        url: "https://images.unsplash.com/photo-1515215316771-2742baa337f4",
    },
    {
        name: "cafe-4",
        url: "https://images.unsplash.com/photo-1493770348161-369560ae357d",
    },
    {
        name: "cafe-5",
        url: "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0",
    },
    {
        name: "cafe-6",
        url: "https://images.unsplash.com/photo-1495214783159-3503fd1b572d",
    },
    {
        name: "dessert-1",
        url: "https://images.unsplash.com/photo-1555565904-89b2842ad409",
    },
    {
        name: "dessert-2",
        url: "https://images.unsplash.com/photo-1548539930-b74b69fd4e08",
    },
    {
        name: "coffee-1",
        url: "https://images.unsplash.com/photo-1447933601403-0c6688de566e",
    },
    {
        name: "coffee-2",
        url: "https://images.unsplash.com/photo-1492158244976-29b84ba93025",
    },
    {
        name: "coffee-3",
        url: "https://images.unsplash.com/photo-1510972527921-ce03766a1cf1",
    },
];
function maxSizeValidator(size) {
    return (info) => {
        if ((info.size / 1000) > size) {
            throw new Error("size");
        }
    };
}
export class FormUpload extends React.Component {
    dialog;
    backupImage;
    constructor(props) {
        super(props);
        const firstImage = props.value[0];
        this.state = {
            loading: false,
            stockActive: false,
            customSourceActive: !!(firstImage && firstImage.not_uc && !this.isStockImage(firstImage)),
        };
    }
    open = () => {
        const { multi, multiAmount, crop, imagesOnly, imageShrink, inputAcceptTypes, maxSize, settings, onChange, onOpen, onClose, } = this.props;
        if (onOpen)
            onOpen();
        const validators = [this.validations];
        if (maxSize) {
            validators.push(maxSizeValidator(maxSize));
        }
        this.dialog = uploadcare.openDialog([], "", {
            ...settings,
            multiple: multi,
            multipleMax: multiAmount || 0,
            imagesOnly: imagesOnly,
            crop: crop || "",
            imageShrink: imageShrink,
            inputAcceptTypes: inputAcceptTypes,
            validators: validators,
            clearable: true,
            previewStep: true
        });
        if (onClose)
            this.dialog.always(onClose);
        this.dialog.done(async (filesPromise) => {
            try {
                this.setState({ loading: true });
                const files = [];
                if (multi) {
                    const promises = filesPromise.files();
                    for (const p of promises) {
                        const result = await p.done();
                        files.push({
                            _id: result.uuid,
                            name: CoreUtils.string.replace_special_charaters(result.name),
                            modifiers: result.cdnUrlModifiers,
                        });
                    }
                }
                else {
                    const result = await filesPromise.done();
                    files.push({
                        _id: result.uuid,
                        name: CoreUtils.string.replace_special_charaters(result.name),
                        modifiers: result.cdnUrlModifiers,
                    });
                }
                onChange(files);
            }
            catch (e) {
                logger.captureException(e);
            }
            finally {
                this.setState({ loading: false });
            }
        });
    };
    validations = (fileInfo) => {
        // This has been temporarily removed until the error message below can be handled upstream. The error message is not showing up on the UI.
        // if (fileInfo.name.match(/[^a-zA-Z0-9.]|\.(?=.*\.)/g)) {
        //     throw new Error('Only letters and numbers are allowed on the filename.');
        // }
    };
    customSourceToggle = () => {
        const { value, onChange } = this.props;
        const { customSourceActive } = this.state;
        if (customSourceActive) {
            onChange(this.backupImage ? [this.backupImage] : []);
        }
        else {
            this.backupImage = value[0];
            onChange([{ _id: "", name: "", not_uc: true }]);
        }
        this.setState({ customSourceActive: !customSourceActive });
    };
    customSourceInputChange = (e) => {
        const v = e.target.value;
        this.props.onChange([{
                _id: v,
                name: "",
                not_uc: true,
            }]);
    };
    remove = () => {
        const { onRemove } = this.props;
        onRemove();
    };
    stockImageChange = (image) => {
        this.setState({ stockActive: false });
        this.props.onChange([{
                _id: image.url + (this.props.stockImageQuery + ""),
                name: image.name,
                not_uc: true,
            }]);
    };
    isStockImage = (i) => {
        return (!!i && i._id.indexOf("https://images.unsplash") !== -1);
    };
    render() {
        const { loading, stockActive, customSourceActive } = this.state;
        const { value, onRemove, multi, stockImages, customSource, isMobile, customImage } = this.props;
        const isUploadedSingle = !multi && value[0] && value[0]._id;
        const isUploadedMulti = multi && value.length > 0;
        const firstImage = value[0];
        return (React.createElement(React.Fragment, null,
            !isMobile && React.createElement("div", { className: "flex-line centered" },
                !customSourceActive && !customImage && (React.createElement(Button, { size: "xs", type: "button", color: "primary-inverse", onClick: this.open },
                    loading && React.createElement(RotateLoader, { size: 2 }),
                    !loading && "Upload")),
                customSource && (React.createElement(Button, { size: "xs", type: "button", className: "m-l-2", style: { minWidth: "120px" }, color: "primary-inverse", onClick: this.customSourceToggle },
                    customSourceActive && "Normal Image",
                    !customSourceActive && "Custom Image")),
                (!customSourceActive && isUploadedSingle) && (React.createElement(Button, { size: "xs", type: "button", className: "m-l-2", color: "primary-inverse", onClick: this.remove }, "Remove")),
                (!customSourceActive && stockImages) && (React.createElement(Button, { size: "xs", type: "button", className: "m-l-2", color: "primary-inverse", onClick: () => this.setState({ stockActive: true }) }, "Stock Images"))),
            isMobile && React.createElement(ImageItemWrapper, null,
                React.createElement(ImageItemStyle, { onClick: this.open }, "Upload Image"),
                React.createElement(ImageItemStyle, { onClick: this.customSourceToggle }, "Custom Image"),
                React.createElement(ImageItemStyle, { onClick: this.remove }, "Remove")),
            (customSourceActive || customImage) && (React.createElement(Input, { type: "url", className: "flex-grow", placeholder: "Image URL (including https://)", value: firstImage ? firstImage._id : "", required: true, onChange: this.customSourceInputChange })),
            (!customSourceActive && isUploadedSingle) && (React.createElement("a", { className: "inline-block m-t-3", href: CoreUtils.image.uc(value[0]), target: "_blank" },
                React.createElement("img", { src: CoreUtils.image.uc(value[0], { resize: "x150", format: "auto" }), style: { maxHeight: isMobile ? undefined : '75px' } }))),
            isUploadedMulti && (React.createElement("div", { className: "m-t-5" },
                React.createElement(ImageUploadThumbnails, { images: value.map((i) => CoreUtils.image.uc(i, { resize: "x75", format: "auto" })), onRemove: (i) => onRemove(i) }))),
            stockImages && (React.createElement(Modal, { active: stockActive, width: "md", close: () => this.setState({ stockActive: false }) },
                React.createElement(ModalTitle, { className: "round-top-sm" },
                    React.createElement("div", null,
                        React.createElement("h4", null, "Stock Images"),
                        React.createElement("p", { className: "lhp m-t-1" },
                            "Let us know what type of images you would like to see here. All images are courtesy of ",
                            React.createElement(LinkTag, { target: "_blank", href: "https://unsplash.com" }, "Unsplash")))),
                React.createElement(ModalContent, { style: { height: "600px", overflowY: "scroll" } },
                    React.createElement("div", { className: "grid-2 md sm-gap" }, StockImages.map((image, i) => (React.createElement("div", { key: i, className: "col m-b-4 cursor text-center", onClick: () => this.stockImageChange(image) },
                        React.createElement("img", { src: image.url + "?fit=min&w=480&h=200&q=50", className: "res-img" }))))))))));
    }
}
//# sourceMappingURL=index.js.map